import { useCallback, useMemo } from 'react'
import { updateLoadingState } from '@sales-center/common'
import { toast } from '@sales-center/components'
import { useHandlers } from '@user/features/Activity/components/ActivityForm/hooks'
import { useAppDispatch } from '@user/store/hooks'
import { useBulkActionContext } from '@user/components/xGrid'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityType: ENTITY_TYPES
}

export function useActions(props: Props) {
  const { entityType } = props
  const { selectedRows, dispatch } = useBulkActionContext()
  const ids = useMemo(() => selectedRows.map((x) => Number(x)), [selectedRows])
  const { handleSubmit } = useHandlers({
    entityId: ids,
    activitiesQuantity: 'bulk',
    entityType,
  })
  const appDispatch = useAppDispatch()

  const onSubmit = useCallback(
    async (model, helpers) => {
      try {
        appDispatch(updateLoadingState('visible'))
        await handleSubmit(model, helpers)
        if (ids.length === 1) {
          toast.success('Activity successfully created')
        } else {
          toast.info('Activities will be assigned to the owner of each record')
        }
        dispatch({ type: 'setActive' })
      } finally {
        appDispatch(updateLoadingState('hidden'))
      }
    },
    [appDispatch, dispatch, handleSubmit, ids.length],
  )

  return {
    onSubmit,
  }
}
